import { useQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { ConsumerAccount } from 'src/shared/features/consumers/schemas/consumer'

export const getAuthenticatedConsumer = () => getRequest<ConsumerAccount>('/consumers/me')

export const useAuthenticatedConsumer = () => {
  return useQuery({
    queryKey: [...queries.consumers.me.queryKey],
    queryFn: async () => {
      const response = await getAuthenticatedConsumer()
      if (!response) {
        throw new Error('Consumer data is undefined')
      }
      return response
    },
    retry: 1,
    staleTime: 30 * 60 * 1000, // 30 minutes
    refetchOnWindowFocus: false,
  })
}
